export const ShieldIcon = ({ size = 16, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M12 22s8-4 8-11V5l-8-3-8 3v6c0 7 8 11 8 11Z"
      stroke={color}
      strokeWidth="2"
    />
  </svg>
);

export const MedalIcon = ({ size = 16, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="8" r="6" stroke={color} strokeWidth="2" />
    <path d="m9 12-2 9 5-3 5 3-2-9" stroke={color} strokeWidth="2" />
  </svg>
);

export const PeopleIcon = ({ size = 16, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
      stroke={color}
      strokeWidth="2"
    />
    <circle cx="9" cy="7" r="4" stroke={color} strokeWidth="2" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke={color} strokeWidth="2" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke={color} strokeWidth="2" />
  </svg>
);

export const PersonIcon = ({ size = 14, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
      stroke={color}
      strokeWidth="2.3"
    />
    <circle cx="9" cy="7" r="4" stroke={color} strokeWidth="2.3" />
  </svg>
);

export const DocSquareIcon = ({ size = 14, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M4 4h16v16H4z" stroke={color} strokeWidth="2.3" />
    <path d="M9 9h6v6H9z" stroke={color} strokeWidth="2.3" />
  </svg>
);

export const ClockIcon = ({ size = 14, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="2.3" />
    <path d="M12 7v5l3 3" stroke={color} strokeWidth="2.3" />
  </svg>
);

export const InfoIcon = ({ size = 15, color = "#3D5A22" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <circle cx="12" cy="12" r="10" stroke={color} strokeWidth="2.2" />
    <path
      d="M12 16v-4M12 8h.01"
      stroke={color}
      strokeWidth="2.2"
      strokeLinecap="round"
    />
  </svg>
);

export const CheckIcon = ({ size = 14, color = "#A3EB64" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path
      d="M20 6 9 17l-5-5"
      stroke={color}
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LockIcon = ({ size = 14, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
    <rect
      x="3"
      y="11"
      width="18"
      height="10"
      rx="2"
      stroke={color}
      strokeWidth="2"
    />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke={color} strokeWidth="2" />
  </svg>
);
